<template>
  <div class="outer">
    <div class="middle">
      <div class="inner">
        <div>
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'AlignMiddle'
	};
</script>

<style scoped>
  .outer {
    display: table;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .middle {
    display: table-cell;
    vertical-align: middle;
  }

  .inner {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
</style>
